interface RatingStarsProps {
  value: number;
  size?: "sm" | "md";
  showValue?: boolean;
}

export default function RatingStars({ value, size = "sm", showValue = true }: RatingStarsProps) {
  const full = Math.floor(value);
  const hasHalf = value - full >= 0.5;
  const boxClass = size === "md" ? "w-4 h-4" : "w-3.5 h-3.5";
  const textClass = size === "md" ? "text-sm" : "text-xs";

  return (
    <div className="flex items-center gap-1.5">
      <div className="flex items-center gap-0.5 text-accent-500">
        {Array.from({ length: 5 }).map((_, index) => {
          const isFull = index < full;
          const isHalf = index === full && hasHalf;
          return (
            <span key={index} className={`${boxClass} flex items-center justify-center`} aria-hidden="true">
              <i className={isFull ? "ri-star-fill" : isHalf ? "ri-star-half-fill" : "ri-star-line"} />
            </span>
          );
        })}
      </div>
      {showValue ? (
        <span className={`${textClass} font-semibold text-foreground-800`}>{value.toFixed(1)}</span>
      ) : null}
      <span className="sr-only">评分 {value.toFixed(1)} 分</span>
    </div>
  );
}